import * as types from '../actions/actionTypes';
import initialState from './initialState';

     
        
export default function cursoReducer(state= initialState.curso, action){
    let newState;
	switch(action.type){
         case types.LOAD_CURSO_LIST_SUCCESS:		
            action.curso.filtroActivo=state.filtroActivo;
            action.curso.filtroActual=state.filtroActual;
            action.curso.showActivos=state.showActivos;
			 action.curso.paginaActual=action.curso.pageable.pageNumber;
			 action.curso.registrosPorPagina=action.curso.size;
            
            return action.curso;

        case types.BORRAR_CURSO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(curso => curso.id !== action.curso.id)];          
			return newState;    
            
        case types.ACTIVAR_CURSO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(curso => curso.id !== action.curso.id)];          
			 return newState;
            
        case types.SET_FILTRO_CURSO:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}